import { Trans } from "@lingui/macro"
import React from "react"
import { Button, BackgroundColor, SectionContainer } from "@silversea-ssc/ui-components-react"
import { websiteUrl } from "../../app-core/_common/localizeWebsiteUrl"
import styles from "./SectionTermsAndConditions.module.scss"

interface Props {
    backgroundColor: BackgroundColor
    termsAndConditionsUrl: string
}

const SectionTermsAndConditions: React.FC<React.PropsWithChildren<Props>> = ({
    backgroundColor,
    termsAndConditionsUrl,
}) => {
    const fullTermsAndConditionsUrl = websiteUrl(termsAndConditionsUrl)

    return (
        <SectionContainer backgroundColor={backgroundColor} className={styles.container}>
            <div className={styles.title}>
                <Trans>Terms & conditions</Trans>
            </div>
            <div className={styles.content}>
                <Trans>
                    To read the full terms and conditions regarding our cruises, please{" "}
                    <Button
                        variant="link"
                        type="a"
                        href={fullTermsAndConditionsUrl}
                        dataContentPiece="terms_and_conditions"
                    >
                        click here
                    </Button>.{" "}
                </Trans>
            </div>
        </SectionContainer>
    )
}

export default SectionTermsAndConditions
